import { DEFAULT_ADMIN_IMPORT_ALIAS } from '@cli-constants/generators.js'
export function resolveActionModulePath(
  actionImportPath: string,
  adminImportAlias = DEFAULT_ADMIN_IMPORT_ALIAS
): string {
  return `${adminImportAlias}/actions/${actionImportPath}`
}
